import { Table } from 'react-bootstrap';
import { SpaceWithOwner } from './GroupBookingsList';

/**
 * MedicalInformationRow
 *
 * Display medical information for a guest/participant
 */
export function MedicalInformationRow({ space }: { space: SpaceWithOwner }) {
  const guestName = space.guest.givenName
    ? `${space.guest.givenName} ${space.guest.familyName}`
    : undefined;
  const ownerName = `${space.owner.givenName} ${space.owner.familyName}`;

  return (
    <tr>
      <td>{guestName || <i>Booked by {ownerName}</i>}</td>
      <td>
        {space.guest.tripForm?.medicalInformation ?? (
          <span className="text-muted">Not provided</span>
        )}
      </td>
    </tr>
  );
}

/**
 * MedicalInformationTable
 *
 * Display medical information for all guests/participants
 */
export default function MedicalInformationTable({
  spaces,
}: {
  spaces: SpaceWithOwner[];
}) {
  return (
    <Table striped bordered responsive>
      <thead>
        <tr>
          <th rowSpan={2}>Name</th>
          <th colSpan={5}>Medical Information</th>
        </tr>
      </thead>
      <tbody>
        {spaces.map((space) => (
          <MedicalInformationRow space={space} key={space.id} />
        ))}
      </tbody>
    </Table>
  );
}
